import { render, staticRenderFns } from "./MinimalAttachments.vue?vue&type=template&id=10bdeba7"
import script from "./MinimalAttachments.vue?vue&type=script&lang=js"
export * from "./MinimalAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports